<template>
  <div>
    <payment-list :cate="cate" ref='paymentList'></payment-list>
  </div>
</template>

<script>
import PaymentList from "@/views/payment/PaymentList.vue";
export default {
  name: "SellerPayment",
  components: {
    PaymentList,
  },
  data() {
    return {
      cate: "SellerPayment",
    };
  },
  mounted(){
    this.$refs.paymentList.init()
  }
};
</script>